import { render, staticRenderFns } from "./text-message.vue?vue&type=template&id=2e79581e&scoped=true&"
import script from "./text-message.vue?vue&type=script&lang=js&"
export * from "./text-message.vue?vue&type=script&lang=js&"
import style0 from "./text-message.vue?vue&type=style&index=0&id=2e79581e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e79581e",
  null
  
)

export default component.exports